import React, { useState, useRef } from 'react';
import { Autocomplete, useJsApiLoader } from '@react-google-maps/api';
import { GOOGLE_MAPS_CONFIG } from './googleMapsConfig';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';

// Global z-index fix for Google Autocomplete suggestions
const PacContainerStyle = () => (
    <style>
        {`
      .pac-container {
        z-index: 99999 !important;
      }
    `}
    </style>
);

const AutoCompleteComponent = ({ changeLatLng }) => {
    const [inputValue, setInputValue] = useState('');
    const autocompleteRef = useRef(null);
    const { isLoaded } = useJsApiLoader(GOOGLE_MAPS_CONFIG);

    const handlePlaceChanged = () => {
        const place = autocompleteRef.current?.getPlace();
        if (place && place.geometry) {
            const lat = place.geometry.location.lat();
            const lng = place.geometry.location.lng();

            changeLatLng({
                lat,
                lng,
                value: {
                    label: place.formatted_address,
                    value: place.formatted_address,
                },
            });
        }
    };

    if (!isLoaded) return <div>Loading...</div>;

    return (
        <Box sx={{ position: 'relative', zIndex: 1 }}>
            <PacContainerStyle />
            <Autocomplete
                onLoad={(autocomplete) => (autocompleteRef.current = autocomplete)}
                onPlaceChanged={handlePlaceChanged}
            >
                <TextField
                    fullWidth
                    label="Proje adresini gir"
                    variant="outlined"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                />
            </Autocomplete>
        </Box>
    );
};

export default AutoCompleteComponent;
